import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDevice } from 'src/utils/device';

const Ads = ({
  slot,
  size,
  sizeMaps,
  device,
  position,
  adsStyle,
  adsClassName,
  ignorePath
}) => {
  const routes = useRouter()?.route;
  const isRenderElem = useDevice(device) && !ignorePath.includes(routes);
  //   console.log({ device, ignorePath, route }, useDevice(device), isRenderElem);

  useEffect(() => {
    if (isRenderElem) {
      window.googletag.cmd.push(() => {
        if (sizeMaps) {
          let sizeMaping = window.googletag.sizeMapping();
          sizeMaps.forEach(sizeMap => {
            sizeMaping = sizeMaping.addSize(...sizeMap);
          });
          sizeMaping.build();
          window.googletag
            .defineSlot(slot, size, position)
            .defineSizeMapping(sizeMaping)
            .addService(window.googletag.pubads() || '')
            .setCollapseEmptyDiv(true, true);
        } else {
          window.googletag
            .defineSlot(slot, size, position)
            .addService(window.googletag.pubads() || '')
            .setCollapseEmptyDiv(true, true);
        }
        window.googletag.pubads().enableSingleRequest();
        window.googletag.enableServices();

        window.googletag.cmd.push(function () { window.googletag.display(position); });
      });
    }
  }, []);

  if (isRenderElem) {
    return (
      <div className={adsClassName}>
        <div id={position} style={adsStyle} />
      </div>
    );
  }
  return null;
};

Ads.propTypes = {
  device: PropTypes.oneOf(['all', 'mobile', 'desktop']).isRequired,
  adsClassName: PropTypes.string.isRequired,
  slot: PropTypes.string.isRequired,
  size: PropTypes.array.isRequired,
  position: PropTypes.string.isRequired,
  sizeMaps: PropTypes.array,
  adsStyle: PropTypes.object,
  setCollapseEmptyDiv: PropTypes.bool,
  ignorePath: PropTypes.array
};

Ads.defaultProps = {
  device: 'all',
  sizeMaps: null,
  adsStyle: {},
  setCollapseEmptyDiv: true,
  ignorePath: []
};

export default Ads;
